'use strict';

/**
 * Removes leading and trailing slashes from a string.
 *
 * @param str - The string to trim slashes from.
 * @returns The string with leading and trailing slashes removed.
 */ function trimSlashes(str) {
    return str.replace(/^\/|\/$/g, '');
}

module.exports = trimSlashes;
